"use client";

import { useIsEditing } from "@/lib/tina-helpers";
import { cn, tinaField } from "@/lib/utils";
import { useEffect, useRef } from "react";

export default function Page({ className, children, defaultTinaField }) {
  const { isEditing } = useIsEditing();
  const tinaFieldRef = useRef(null);
  const hasClickedRef = useRef(false);

  useEffect(() => {
    if (!isEditing || hasClickedRef.current) return;

    const handleTinaEnabled = () => {
      if (hasClickedRef.current) return;

      if (document.body.classList.contains("__tina-quick-editing-enabled")) {
        setTimeout(() => {
          tinaFieldRef.current?.click();
          hasClickedRef.current = true;
        }, 300);
      }
    };

    // Check immediately in case already enabled
    handleTinaEnabled();

    // Watch for class being added
    const observer = new MutationObserver(handleTinaEnabled);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [isEditing]);

  return (
    <div className={cn(className, "flex-1")}>
      {defaultTinaField && <div ref={tinaFieldRef} data-tina-field={tinaField(defaultTinaField)} className="hidden" />}
      {children}
    </div>
  );
}
